import React from 'react';

// Renders musical accidentals (♯, ♭, ♮) as smaller, raised superscripts
// Usage: <AccidentalText text="C♯" />
export default function AccidentalText({ text, as: Tag = 'span', style = {}, accidentalScale = 0.6, raiseEm = 0.35 }) {
  if (text == null) return null;
  const s = String(text);
  const nodes = [];
  for (let i = 0; i < s.length; i++) {
    const ch = s[i];
    if (ch === '♯' || ch === '♭' || ch === '♮') {
      nodes.push(
        <span
          key={`acc-${i}`}
          style={{
            fontSize: `${accidentalScale}em`,
            position: 'relative',
            top: `-${raiseEm}em`,
            lineHeight: 1,
            display: 'inline-block',
            marginLeft: '0.02em',
          }}
        >
          {ch}
        </span>
      );
    } else {
      nodes.push(<span key={`ch-${i}`}>{ch}</span>);
    }
  }
  return <Tag style={style}>{nodes}</Tag>;
}
